import React, { useEffect, useState } from "react";
import {
    Badge,
    Button,
    Card,
    Col,
    Row,
    Spinner,
    Table
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { t } from "i18next";

import DataManager from "../../../General/DataManager";
import UserClass from "../../../General/LocalStorage/UserClass";
import Functions from "../../../General/Functions";


const TicketDetails = () => {
    const navigate = useNavigate();
    const { routeId, departurePort, number } = useParams();

    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getTicketDetails = async () => {
            try {
                setLoading(true);

                const token = UserClass.getInstance().getTokenUser();

                const { data, msgError } =
                    await DataManager.getRouteTicketDetails(
                        token,
                        routeId,
                        departurePort,
                        number
                    );

                if (msgError) {
                    Functions.alertMsg(msgError);
                    return;
                }

                setTickets(data || []);
            } catch {
                Functions.alertMsg(t("msgErrorGeneral"));
            } finally {
                setLoading(false);
            }
        };

        getTicketDetails();
    }, [routeId, departurePort, number]);

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const getStatusVariant = (status) => {
        switch ((status || "").toLowerCase()) {
            case "boarded":
                return "success";
            case "issued":
                return "primary";
            case "cancelled":
                return "danger";
            default:
                return "secondary";
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" />
            </div>
        );
    }

    return (
        <>
            <Card
                className="border-0 shadow-lg rounded-4 overflow-hidden mb-4"
                style={{
                    background:
                        "linear-gradient(135deg,#0d6efd 0%, #4f8dfd 100%)",
                }}
            >
                <Card.Body className="text-white p-4">
                    <Button
                        variant="link"
                        className="text-white text-decoration-none p-0 mb-3"
                        onClick={() => navigate(-1)}
                    >
                        ← {t("back")}
                    </Button>

                    <h2 className="fw-bold mb-2">
                        {t("ticket_details")}
                    </h2>



                    <div className="text-white-50">
                        {t("departure_port")}: {departurePort}
                    </div>

                    <div className="text-white-50">
                        {t("arrival_port")}: {tickets[0]?.destinationPort || ''}
                    </div>

                    <div className="text-white-50">
                        {t("departure_time")}: {new Date(tickets[0]?.departureTime).toLocaleString() || ''}
                    </div>
                    {number && (
                        <div className="text-white-50">
                            {t("ticket")}: {number}
                        </div>
                    )
                    }
                    {tickets[0]?.bookingReference && (
                        <div className="text-white-50">
                            {t("booking")}: {tickets[0]?.bookingReference}
                        </div>
                    )}

                </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 rounded-4">
                <Card.Header className="bg-white fw-bold">
                    {t("tickets")} ({tickets.length})
                </Card.Header>

                <Card.Body className="p-0">
                    {tickets.length === 0 ? (
                        <div className="text-center p-5 text-muted">
                            No tickets found.
                        </div>
                    ) : (
                        <Table responsive hover className="mb-0 align-middle">
                            <thead>
                                <tr>
                                    <th>{t("owner")}</th>
                                    <th>{t("status")}</th>
                                    <th>{t("boardedFrom")}</th>
                                    <th>{t("boardedDate")}</th>
                                    <th>{t("issue_date")}</th>
                                    <th>{t("quantity")}</th>
                                    <th>{t("type")}</th>
                                    <th>{t("price")}</th>
                                    <th>{t("tariff")}</th>
                                    <th>{t("channel")}</th>
                                    <th>{t("issuer")}</th>

                                </tr>
                            </thead>

                            <tbody>
                                {tickets.map((ticket) => (
                                    <tr key={ticket.id}>
                                        <td>
                                            {ticket.holderName || "-"}
                                        </td>
                                        <td>
                                            <Badge
                                                bg={getStatusVariant(
                                                    ticket.stato
                                                )}
                                            >
                                                {ticket.stato}
                                            </Badge>
                                        </td>

                                        <td>
                                            {ticket?.boardedFrom || "-"}
                                        </td>

                                        <td>
                                            {ticket?.boardedDate ? new Date(ticket?.boardedDate)?.toLocaleString() : "-"}
                                        </td>


                                        <td>
                                            {new Date(ticket?.issueDate).toLocaleString()}

                                        </td>

                                        <td>
                                            {ticket.qty}
                                        </td>

                                        <td>
                                            {ticket?.type}
                                        </td>

                                        <td>
                                            {ticket.price || "-"}
                                        </td>

                                        <td>{ticket?.tariff || "-"}</td>
                                        <td>
                                            {ticket?.issueType ?
                                                (ticket?.issueType === "ticketOffice"
                                                    ? t("ticket_office")
                                                    : ticket?.issueType)
                                                : "-"}
                                        </td>

                                        <td>
                                            {ticket.issuedOperator || "-"}
                                        </td>





                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card.Body>
            </Card>

            <div className="d-flex justify-content-end mt-4">
                <Button onClick={() => navigate(-1)}>
                    {t("back")}
                </Button>
            </div>
        </>
    );
};

export default TicketDetails;